module.exports = __webpack_public_path__ + "img/whatsapp.91d403ea.png";